module.exports = __webpack_public_path__ + "img/handwash.93d13074.png";